(function () {

    'use strict';

    angular.module('Services').service('MarketPlaceReportTableService', MarketPlaceReportTableService);

    MarketPlaceReportTableService.$inject = ['MarketPlaceService', 'TableLiteFactory'];

    function MarketPlaceReportTableService(MarketPlaceService, TableLiteFactory) {
        var tableStructure = {
            config: {
                noPagination: false,
                noHeaders: false,
                noItemsView: false,
                noTableFooter: false
            },
            headers: [{
                label: 'MARKETPLACE', // Column Name
                viewName: 'marketplaceType',
                filterName: 'marketplaceType',
                filter: {
                    type: 'text',
                    placeholder: 'Search',
                    onSubmit: function (header) {
                        sendRequest(evaluateFilter(header));
                    }
                },
                headerFn: function () {
                    sort(this.filterName);
                }
            }, {
                label: 'CUSTOMER',
                viewName: 'customer',
                filterName: 'customer',
                filter: {
                    type: 'text',
                    placeholder: 'Search',
                    onSubmit: function (header) {
                        sendRequest(evaluateFilter(header));
                    }
                },
                headerFn: function () {
                    sort(this.filterName);
                }
            }, {
                label: 'ANNUAL SPEND YTD',
                viewName: 'annualSpend',
                filterName: 'annualSpend',
                headerFn: function () {
                    sort(this.filterName);
                }
            }],

            data: []
        };
        const tableActions = new TableLiteFactory(tableStructure,
            {
                serviceCallback: MarketPlaceService.getAnnualReport,
                callbackFormat: ['success','error','filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    toastr.error(err);
                },
                defaultFilters : {
                    size: 20,
                    page: 0,
                    sort: 'id,desc'
                }
            }
        );
        const sort = tableActions.sort;
        const evaluateFilter = tableActions.evaluateFilter;
        const sendRequest = tableActions.sendRequest;

        function buildTableData(data, pagination) {
            /*** START - Building of Data ***/
            tableActions.initializeTableData(data);
            /*tableStructure.data = data.content;*/
            tableStructure.data = [];
            /*** END - Building of Data ***/
        };
        return tableStructure;
    };
})();



// WEBPACK FOOTER //
// ./js/services/tables/MarketPlaceReportTableService.js